/* Enlighten Me journey landing, from the approved preview v16.
   The five scenes, their timings and their motion are the prototype's own.
   Content comes from the section's settings and topic blocks. The last
   button opens Enlighten Me Talk with the chosen topic's starter waiting in
   the box; nothing is ever sent for the visitor. */
(function(){
  'use strict';
  var reduced=function(){return window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;};

  function init(root){
    if(!root||root.dataset.emReady==='true')return;
    root.dataset.emReady='true';
    var config={methodIntro:'',topics:[]};
    try{config=JSON.parse(root.querySelector('[data-em-landing-config]').textContent);}catch(e){}
    var $=function(s){return root.querySelector(s);};
    var scenes=[].slice.call(root.querySelectorAll('.scene'));
    var step=$('[data-step]'),selected=$('[data-selected-issue]'),typed=$('[data-typed]'),cursor=$('[data-cursor]');
    var persona=$('[data-persona]'),followup=$('[data-followup]'),fallback=$('[data-fallback]');
    var intro=$('[data-phase="intro"]'),journals=$('[data-phase="journals"]'),notes=$('[data-phase="notes"]');
    var methodTyped=$('[data-method-typed]'),methodCursor=$('[data-method-cursor]'),skip=$('[data-skip]');
    var finalCta=$('[data-final-cta]'),toNotes=$('[data-to-notes]');
    var appPath=root.dataset.appPath||'/apps/enlighten-me',defaultCta=root.dataset.defaultCta||'';
    var current=null,typingTimer=null,methodTimers=[];

    // A topic id is one of the app's own; anything else opens plain Talk.
    function destination(topic){
      var id=topic&&/^[a-z]{1,32}$/.test(topic.topic||'')?topic.topic:'';
      return appPath+(id?'?topic='+encodeURIComponent(id):'?open=talk');
    }
    function later(fn,ms){var id=setTimeout(fn,ms);methodTimers.push(id);return id;}
    function clearMethod(){methodTimers.forEach(clearTimeout);methodTimers=[];}
    function resetMethod(){
      clearMethod();
      if(skip)skip.hidden=true;
      if(methodTyped)methodTyped.textContent='';
      if(methodCursor)methodCursor.style.display='';
      [intro,journals,notes].forEach(function(el){if(!el)return;el.hidden=el!==intro;el.classList.remove('show','fade-out');});
    }
    function typeIntro(text,done){
      var i=0;
      if(reduced()){methodTyped.textContent=text;if(methodCursor)methodCursor.style.display='none';done&&done();return;}
      (function tick(){
        methodTyped.textContent=text.slice(0,i);
        if(i<text.length){i+=1;later(tick,44);}
        else{if(methodCursor)methodCursor.style.display='none';done&&done();}
      })();
    }
    function revealNotes(){
      clearMethod();
      intro.hidden=true;journals.hidden=true;notes.hidden=false;
      notes.classList.remove('fade-out');notes.classList.add('show');
      if(skip)skip.hidden=true;
    }
    function startMethod(){
      resetMethod();
      if(reduced()){revealNotes();return;}
      if(skip)skip.hidden=false;
      intro.hidden=false;intro.classList.add('show');
      typeIntro(config.methodIntro||'',function(){
        later(function(){
          intro.classList.add('fade-out');
          later(function(){
            intro.hidden=true;journals.hidden=false;journals.classList.add('show');
            later(function(){journals.classList.add('fade-out');later(revealNotes,550);},4300);
          },550);
        },850);
      });
    }
    function showStage(n){
      var stage=String(n);
      root.dataset.stage=stage;
      scenes.forEach(function(s){s.classList.toggle('active',s.dataset.scene===stage);});
      if(stage==='4')startMethod();else resetMethod();
      var top=root.getBoundingClientRect().top+window.pageYOffset;
      window.scrollTo({top:top,behavior:reduced()?'auto':'smooth'});
    }

    [].forEach.call(root.querySelectorAll('[data-first]'),function(btn){
      btn.addEventListener('click',function(){
        if(btn.dataset.first==='yes'){showStage(2);return;}
        [].forEach.call(root.querySelectorAll('[data-first]'),function(b){b.style.opacity='.48';});
        btn.style.opacity='1';
        step.disabled=false;step.classList.add('ready','show');
      });
    });
    step.addEventListener('click',function(){showStage(2);});

    function startResponse(index){
      var topic=config.topics[index];if(!topic)return;
      clearInterval(typingTimer);
      current=topic;
      selected.textContent=topic.label;
      typed.textContent='';cursor.style.display='';
      persona&&persona.classList.remove('typing');
      followup.hidden=true;fallback.hidden=true;
      toNotes.hidden=true;toNotes.classList.remove('show');
      showStage(3);
      var text=topic.reply||'';
      if(reduced()){typed.textContent=text;cursor.style.display='none';followup.hidden=false;return;}
      persona&&persona.classList.add('typing');
      var i=0;
      typingTimer=setInterval(function(){
        typed.textContent+=text[i]||'';i++;
        if(i>=text.length){
          clearInterval(typingTimer);
          setTimeout(function(){cursor.style.display='none';persona&&persona.classList.remove('typing');followup.hidden=false;},350);
        }
      },18);
    }
    [].forEach.call(root.querySelectorAll('[data-topic-index]'),function(b){
      b.addEventListener('click',function(){startResponse(Number(b.dataset.topicIndex));});
    });

    $('[data-followup-yes]').addEventListener('click',function(){followup.hidden=true;fallback.hidden=true;showStage(4);});
    $('[data-followup-no]').addEventListener('click',function(){
      followup.hidden=true;fallback.hidden=false;
      // Not yet is never a dead end: the next step appears, quietly, beneath.
      toNotes.hidden=false;
      requestAnimationFrame(function(){requestAnimationFrame(function(){toNotes.classList.add('show');});});
    });
    toNotes.addEventListener('click',function(){showStage(4);});
    if(skip)skip.addEventListener('click',revealNotes);
    $('[data-to-final]').addEventListener('click',function(){
      finalCta.textContent=(current&&current.cta)||defaultCta;
      finalCta.href=destination(current);
      showStage(5);
    });
    finalCta.href=destination(null);

    // #apps opens the last scene directly, as in the preview.
    if(window.location.hash==='#apps'&&!window.Shopify?.designMode)showStage(5);
  }

  function initAll(){[].forEach.call(document.querySelectorAll('[data-em-landing]'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  // The Theme Editor redraws a section when it is edited.
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[data-em-landing]'));});
})();
